import type { PublicLocale } from './locale';
import source from './translations/source.json';
import en from './translations/en.json';
import de from './translations/de.json';
import es from './translations/es.json';
import it from './translations/it.json';
import pl from './translations/pl.json';

export const PUBLIC_LANGUAGE_NAMES: Record<PublicLocale, string> = {
  cs: 'Čeština',
  sk: 'Slovenčina',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  pl: 'Polski',
};

export const PUBLIC_TRANSLATIONS: Record<
  Exclude<PublicLocale, 'cs'>,
  Readonly<Record<string, string>>
> = { sk: source, en, de, es, it, pl };

// A missing translation must fail the build/render checks, never silently
// display Czech copy under another language's URL and metadata.
export function translatePublic(
  locale: PublicLocale,
  cs: string,
  sk: string,
): string {
  if (locale === 'cs') return cs;
  if (locale === 'sk') return sk;
  const translated = PUBLIC_TRANSLATIONS[locale][cs];
  if (!translated?.trim()) {
    throw new Error(`Missing public translation (${locale}): ${cs}`);
  }
  return translated;
}
